import RewardsBrandingCupIcon from "@apps/rewards/components/Icons/RewardsBrandingIconsOptions/RewardsBrandingCupIcon.svelte";
import RewardsBrandingGiftIcon from "@apps/rewards/components/Icons/RewardsBrandingIconsOptions/RewardsBrandingGiftIcon.svelte";
import RewardsBrandingRibbonIcon from "@apps/rewards/components/Icons/RewardsBrandingIconsOptions/RewardsBrandingRibbonIcon.svelte";
import RewardsBrandingStarIcon from "@apps/rewards/components/Icons/RewardsBrandingIconsOptions/RewardsBrandingStarIcon.svelte";
import RewardsBrandingTicketIcon from "@apps/rewards/components/Icons/RewardsBrandingIconsOptions/RewardsBrandingTicketIcon.svelte";

import { BRANDING_LAUNCHER_ICON } from "../modules/StorefrontValues/constants";

//Variables
export const RTL_DIRECTION = "rtl";
export const REMOVE_PROTOCOL_REGEX = /^https?:\/\//;
export const REFERRAL_SHARE_PATH = "referral";
export const REFERRAL_SHARE_CHANNELTYPE = "channelType";
export const POINTS_SHARE_PATH = "points";
export const EARNING_RULE_SHARE_RULE_ID = "ruleId";
export const EARNING_RULE_SHARE_EVENT_TYPE = "eventType";
export const SOCIAL_SHARE_CHANNELNAME = "channelName";
export const TOKEN = "token";
export const REWARDS_STOREFRONT_BASE_URL =
    __APP_ENV__ === "development"
        ? "https://app.dev.growave.io/storefront-api/rewards-storefront/v2"
        : "https://app.growave.io/storefront-api/rewards-storefront/v2";
export const SHARE_LINK = "{{ share_link }} ";
export const REFERRAL_CONTEXT_STORAGE_KEY = "gwReferralContext";
export const REFERRAL_CONTEXT_SEARCH_PARAM = "referralContext";
export const PERCENTAGE_SYMBOL = "%";
export const REQUEST_INTERVAL_MS = 10000;
export const REQUEST_START_DELAY_MS = 2500;

export const KEY_BOARD_EVENT_KEYS = {
    ArrowDown: "ArrowDown",
    ArrowUp: "ArrowUp",
    Space: "Space",
    Escape: "Escape",
    Enter: "Enter",
} as const;

export const ICON_SIZES = {
    extraSmall: "xs", // 60x60
    small: "sm", // 160x160
    medium: "md", // 360x180
    large: "lg", // 720x360
    extraLarge: "xlg", // 1024x768
} as const;

export const REWARDS_WIDGETS_PLACEHOLDERS = {
    drawerWidgetPlaceholder: "body",
    popUpWidgetWrapperPlaceholder: ".gw-widget-placeholder",
    hubWidgetPlaceholder: ".gw-rd-popup-root-widget-placeholder",
    joinNowModalWidgetPlaceholder: "body",
    verifyAccountModalWidgetPlaceholder: "body",
    waysToEarnPageWidgetPlaceholder:
        ".gw-rd-ways-to-earn-page-widget-placeholder",
    waysToEarnPageWidgetModalPlaceholder: "body",
    waysToSpendPageWidgetPlaceholder:
        ".gw-rd-ways-to-spend-page-widget-placeholder",
    waysToSpendPageWidgetModalPlaceholder: "body",
    referralProgramPageWidgetPlaceholder:
        ".gw-rd-referral-program-page-widget-placeholder",
    referralsPageWidgetPlaceholder: ".gw-rd-referrals-page-widget-placeholder",
    historyPageWidgetPlaceholder: ".gw-rd-history-page-widget-placeholder",
    availableRewardsPageWidgetPlaceholder:
        ".gw-rd-available-rewards-page-widget-placeholder",
    availableRewardsPageWidgetModalPlaceholder: "body",
    vipTiersPageWidgetPlaceholder: ".gw-rd-vip-tiers-page-widget-placeholder",
    vipTiersCardWidgetPlaceholder: ".gw-rd-vip-tiers-card-widget-placeholder",
    vipTiersSingleProgressWidgetPlaceholder:
        ".gw-rd-vip-tiers-single-progress-widget-placeholder",
    vipTiersMultiProgressWidgetPlaceholder:
        ".gw-rd-vip-tiers-multi-progress-widget-placeholder",
    faqPageWidgetPlaceholder: ".gw-rd-faq-page-widget-placeholder",
    earnPointsProductPageWidgetPlaceholder:
        ".gw-rd-earn-points-product-page-widget-placeholder",
    earnPointsCartWidgetPlaceholder:
        ".gw-rd-earn-points-cart-widget-placeholder",
    loyaltyInfoPageWidgetPlaceholder:
        ".gw-rd-loyalty-info-page-widget-placeholder",
    emptyStatePageWidgetPlaceholder: ".gw-rd-page-wrapper",
    qrCodeModalWidgetPlaceholder: "body",
    customerPointsBalanceInlineWidgetPlaceholder:
        ".gw-rd-customer-points-balance-inline-widget-placeholder",
    availableRewardsCartWidgetPlaceholder:
        ".gw-rd-available-rewards-cart-widget-placeholder",
    refundDiscountModalWidgetPlaceholder: "body",
    freeProductSliderWidgetPlaceholder:
        ".gw-rd-free-product-slider-widget-placeholder",
} as const;

export const TRANSLATION_NAMESPACES = {
    commonCriticalPoints: "common.critical.Points",
    criticalDrawerWidget: "rewards.critical.RewardsPopUpWidget", //for drawer widget take the same namespace as popUpWidget
    criticalPopUpWidget: "rewards.critical.RewardsPopUpWidget",
    criticalJoinNowModalWidget: "rewards.critical.RewardsJoinNowModalWidget",
    criticalVerifyAccountModalWidget:
        "rewards.critical.RewardsVerifyAccountModalWidget",
    hubWidget: "rewards.RewardsPopUpWidget", //Legacy namespace for backward compatibility with translations
    hubWidgetV2: "rewards.RewardsHubWidgetV2",
    waysToEarnPageWidget: "rewards.RewardsWaysToEarnPageWidget",
    availableRewardsPageWidget: "rewards.RewardsAvailableRewardsPageWidget",
    waysToSpendPageWidget: "rewards.RewardsWaysToSpendPageWidget",
    vipTiersPageWidget: "rewards.RewardsVipTiersPageWidget",
    vipTiersCardWidget: "rewards.RewardsVipTiersCardWidget",
    vipTiersSingleProgressWidget: "rewards.RewardsVipTiersSingleProgressWidget",
    vipTiersSingleProgressWidgetV2:
        "rewards.RewardsVipTiersSingleProgressWidgetV2",
    vipTiersMultiProgressWidget: "rewards.RewardsVipTiersMultiProgressWidget",
    referralProgramPageWidget: "rewards.RewardsReferralProgramPageWidget",
    referralsPageWidget: "rewards.RewardsReferralsPageWidget",
    historyPageWidget: "rewards.RewardsHistoryPageWidget",
    faqPageWidget: "rewards.RewardsFaqPageWidget",
    emptyStatePageWidget: "rewards.RewardsEmptyStatePageWidget",
    loyaltyInfoPageWidget: "rewards.RewardsLoyaltyInfoPageWidget",
    criticalEarnPointsProductPageWidget:
        "rewards.critical.RewardsEarnPointsProductPageWidget",
    earnPointsCartWidget: "rewards.RewardsEarnPointsCartWidget",
    availableRewardsCartWidget: "rewards.RewardsAvailableRewardsCartWidget",
    refundDiscountModalWidget: "rewards.refundDiscountModalWidget",
    freeProductSliderWidget: "rewards.RewardsFreeProductSliderWidget",
} as const;

//Do not delete or edit enum DATA_GW_SELECTORS
export const DATA_GW_SELECTORS = {
    earningRulePopup: "gw-earning-rule-popup",
    variableDiscountPopUpRootWidget: "gw-popup-root-widget-variable-discount",
    spendingRulesPopUpRootWidget: "gw-popup-root-widget-spending-rules",
    tierPopup: "gw-tier-popup",
    customerRewardsPopup: "gw-customer-rewards-popup",
    waysToEarnPageWidget: "gw-ways-to-earn-page-widget",
    waysToEarnPageWidgetModal: "gw-ways-to-earn-page-widget-modal",
    waysToSpendPageWidget: "gw-ways-to-spend-page-widget",
    waysToSpendPageWidgetModal: "gw-ways-to-spend-page-widget-modal",
    tierPage: "gw-tier-page",
    vipTiersCardWidget: "gw-vip-tiers-card-widget",
    vipTiersMultiProgressWidget: "gw-vip-tiers-multi-progress-widget",
    availableRewardsPageWidget: "gw-available-rewards-page-widget",
    availableStoreCreditPageWidget: "gw-available-store-credit-page-widget",
    availableRewardsPageWidgetModal: "gw-available-rewards-page-widget-modal",
    qrCodeRewardsModal: "gw-qr-code-rewards-modal",
} as const;

export const REWARDS_BRANDING_ICONS = {
    [BRANDING_LAUNCHER_ICON.default]: RewardsBrandingCupIcon,
    [BRANDING_LAUNCHER_ICON.gift]: RewardsBrandingGiftIcon,
    [BRANDING_LAUNCHER_ICON.ticket]: RewardsBrandingTicketIcon,
    [BRANDING_LAUNCHER_ICON.star]: RewardsBrandingStarIcon,
    [BRANDING_LAUNCHER_ICON.ribbon]: RewardsBrandingRibbonIcon,
};
